import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {AuthService} from "@sh/services/auth/auth.service";
import {Observable, switchMap, take} from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.auth.authCredentials$.pipe(take(1), switchMap((credentials) => {
      if (!credentials || !credentials.idToken) {
        return next.handle(req);
      }
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${credentials.idToken}`)
      });
      return next.handle(authReq);
    }))
  }
}
